import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  PagedResponse,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";
import { Activity } from "../domain/Activity";

const DEFAULT_PAGE_SIZE = 999;
export class ActivitiesService extends BaseRemoteService {
  public async search(
    resourceId: string,
    params: QueryParams,
    opts: Opts
  ): Promise<PagedResponse<Activity>> {
    const url = `${this.apiRoot}/activity/${resourceId}/${paramsToSearchString({
      ...params,
      pageSize: DEFAULT_PAGE_SIZE,
    })}`;

    // the activity feed is ordered by the api (there is significance to the order that we receive
    //  so beware resorting it)
    return await super.getRequest<PagedResponse<Activity>>(url, opts);
  }
}
